import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import SwiperCore, { Keyboard, FreeMode, Autoplay, Mousewheel, A11y } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import { useReducedMotion } from 'framer-motion';
import { AutoplayHelper } from '@common/utils/carouselUtils';
import { useTranslation } from 'react-i18next';
import LatestCarouselTile from './LatestTile';
import customEventBus from '@common/scripts/libs/eventBus';
import useMediaQueries from '@stone/hooks/useMediaQueries';
SwiperCore.use([Keyboard, Autoplay, FreeMode, Mousewheel, A11y]);
const LatestCarousel = (props) => {
    const { t } = useTranslation();
    const { isDesktop, isWideDesktop } = useMediaQueries();
    const slidesInView = useMemo(() => (isWideDesktop ? 8 : isDesktop ? 6 : null), [isDesktop, isWideDesktop]);
    const swiperRef = useRef();
    const container = useRef();
    const isRedusced = useReducedMotion();
    const [isAutoplayActive, setIsAutoplayActive] = useState(!isRedusced);
    const [isLocked, setIsLocked] = useState(false);
    const [lockPause, setLockPause] = useState(false);
    const [autoplayHelper, setAutoplayHelper] = useState();
    const [slides, setSlides] = useState([]);
    const [editorialSlides, setEditorialSlides] = useState([]);
    const swipeTiming = '500ms';
    const timingSnap = 200;
    useEffect(() => {
        let _uuid = props.uuid;
        if (autoplayHelper) {
            let handlePauseButton = (data) => {
                if (autoplayHelper) {
                    if (data === null || data === void 0 ? void 0 : data.lockpause) {
                        setLockPause(autoplayHelper.isAutoplayActive);
                    }
                    autoplayHelper.handlePauseButton();
                    return true;
                }
            };
            customEventBus.on(`toggleplaypause:${_uuid}`, handlePauseButton);
            return () => {
                customEventBus.off(`toggleplaypause:${_uuid}`, handlePauseButton);
            };
        }
    }, [autoplayHelper]);
    let mouseMovestimeout;
    const debounceFunction = (fun, timeout, waitfor) => {
        return () => {
            timeout && clearTimeout(mouseMovestimeout);
            timeout = setTimeout(() => {
                fun();
            }, waitfor || 500);
        };
    };
    const checkSlides = useCallback((slides) => {
        let array = [...slides];
        const slidesToCover = slidesInView / 2;
        if (slides.length <= slidesToCover) {
            //populate with an for cycle until array has reached a lenght = to the slides to cover
            let coeff = parseInt(Math.floor(slidesToCover / slides.length).toFixed(0));
            for (let i = 0; i < coeff; i++) {
                array = [...array, ...slides];
            }
        }
        return array;
    }, [slidesInView]);
    useEffect(() => {
        var _a, _b;
        let slides = props.products;
        let editorialSlides = props.editorialProducts;
        if (slidesInView && (((_a = props.products) === null || _a === void 0 ? void 0 : _a.length) || ((_b = props.editorialProducts) === null || _b === void 0 ? void 0 : _b.length))) {
            if (props.products) {
                slides = checkSlides(props.products);
            }
            if (props.editorialProducts) {
                editorialSlides = checkSlides(props.editorialProducts);
            }
        }
        setSlides(slides);
        setEditorialSlides(editorialSlides);
    }, [slidesInView, props]);
    return (React.createElement("div", { ref: container, className: "latest_carousel--container", onMouseEnter: debounceFunction(() => !lockPause && (autoplayHelper === null || autoplayHelper === void 0 ? void 0 : autoplayHelper.pauseCarousel()), mouseMovestimeout, 1), onMouseLeave: debounceFunction(() => !lockPause && (autoplayHelper === null || autoplayHelper === void 0 ? void 0 : autoplayHelper.playCarousel()), mouseMovestimeout, 500) },
        React.createElement(Swiper, { className: "latest_carousel--carousel", onSwiper: (swiper) => {
                swiperRef.current = swiper;
                console.log(swiper);
                const helper = new AutoplayHelper(swiperRef.current, setIsAutoplayActive, isAutoplayActive, setIsLocked);
                setAutoplayHelper(helper);
                setTimeout(() => {
                    customEventBus.emit(`carouselinit:${props.uuid}`, { swiper: swiper, helper: helper });
                }, 0);
            }, onResize: () => {
                if (!swiperRef.current.autoplay.running && !isLocked) {
                    autoplayHelper === null || autoplayHelper === void 0 ? void 0 : autoplayHelper.playCarousel();
                }
            }, onScroll: (swiper, e) => {
                swiper.wrapperEl.style.transitionDuration = swipeTiming;
            }, onTouchStart: (swiper) => {
                autoplayHelper === null || autoplayHelper === void 0 ? void 0 : autoplayHelper.pauseCarousel();
            }, onTouchEnd: () => {
                swiperRef.current.slideReset(timingSnap);
            }, onAutoplayStart: () => {
                setTimeout(() => {
                    customEventBus.emit(`playerstatuschange:${props.uuid}`, { uuid: props.uuid, status: 'pause' });
                }, 0);
            }, onAutoplayStop: () => {
                setTimeout(() => {
                    customEventBus.emit(`playerstatuschange:${props.uuid}`, { uuid: props.uuid, status: 'play' });
                }, 0);
            }, slidesPerView: 1.5, spaceBetween: 12, breakpoints: {
                [window.mqObj.lg]: {
                    slidesPerView: 6,
                },
                [window.mqObj.xxl]: {
                    slidesPerView: 8,
                },
            }, threshold: 10, freeMode: { enabled: true }, autoplay: !isRedusced && {
                delay: 0,
                disableOnInteraction: false,
            }, speed: !isRedusced && 5000, mousewheel: { forceToAxis: true, thresholdDelta: 20 }, a11y: {
                enabled: true,
                slideRole: 'group',
                itemRoleDescriptionMessage: 'slide',
                slideLabelMessage: '',
                prevSlideMessage: t('label.previouspicture'),
                nextSlideMessage: t('label.nextpicture'),
            }, watchSlidesProgress: true, keyboard: true, loop: true }, slides === null || slides === void 0 ? void 0 :
            slides.map((product, i) => (React.createElement(SwiperSlide, { className: "latest_carousel--slide", key: product.id + i.toString() }, ({ isVisible }) => (React.createElement(LatestCarouselTile, { onFocus: () => {
                    autoplayHelper === null || autoplayHelper === void 0 ? void 0 : autoplayHelper.pauseCarousel();
                }, parentUuid: props.uuid, product: product, position: i, focusDisabled: !isVisible }))))), editorialSlides === null || editorialSlides === void 0 ? void 0 :
            editorialSlides.map((product, i) => (React.createElement(SwiperSlide, { className: "latest_carousel--slide", key: product.id + i.toString() }, ({ isVisible }) => (React.createElement(LatestCarouselTile, { onFocus: () => {
                    autoplayHelper === null || autoplayHelper === void 0 ? void 0 : autoplayHelper.pauseCarousel();
                }, parentUuid: props.uuid, editorialProduct: product, position: i, focusDisabled: !isVisible }))))))));
};
export default LatestCarousel;
